var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { StyledTextField } from './styles';
import { InputAdornment } from '@mui/material';
export var OldTextField = function (_a) {
    var size = _a.size, InputProps = _a.InputProps, InputLabelProps = _a.InputLabelProps, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment, props = __rest(_a, ["size", "InputProps", "InputLabelProps", "startAdornment", "endAdornment"]);
    // Определяет, может ли сворачиваться Label при фокусе | клике по инпуту.
    // size !== 'small' -> фикс для Autocomplete ( Autocomplete может быть small и есть скрытый endAdornment {стрелка выпадающего списка} )
    var inputLabelProps = startAdornment || endAdornment ? { shrink: false } : {};
    var generalAdornments = {
        startAdornment: startAdornment && (React.createElement(InputAdornment, { position: 'start' }, startAdornment)),
        endAdornment: endAdornment && (React.createElement(InputAdornment, { position: 'end' }, endAdornment)),
    };
    return (React.createElement(StyledTextField, __assign({}, props, { size: size, InputLabelProps: __assign(__assign({}, InputLabelProps), inputLabelProps), InputProps: __assign(__assign({}, generalAdornments), InputProps) })));
};
